<template>
	<!-- 基础信息表单组件 -->
	<div class="flex-component">
		<div class="flex-title"><label>基本信息</label></div>
		<el-row>
			<el-col :span="16">
				<el-form ref="information" :model="information" :rules="rules" label-width="90px" size="small">
					<el-form-item label="机构名称:" prop="CustomerName">
						<el-input v-model="information.CustomerName" clearable maxlength="40" placeholder="请输入机构名称" :disabled="operationState > 2 || isSubStore"></el-input>
					</el-form-item>
					<el-form-item label="客户类型:" prop="CustomerType" class="text-left">
						<el-select
							v-model="information.CustomerType"
							@change="contactsNameChange"
							placeholder="请选择客户类型"
							:disabled="operationState > 2 || isSubStore"
							style="width: 140px;"
						>
							<el-option label="药店" :value="1"></el-option>
							<el-option label="诊所" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="经营性质:" prop="BusinessNature" class="text-left" v-if="information.CustomerType === 2">
						<el-select
							v-model="information.BusinessNature"
							@change="businessNatureChange"
							placeholder="请选择经营性质"
							:disabled="operationState > 2 || isSubStore"
							style="width: 140px;"
						>
							<el-option label="营利性" :value="1"></el-option>
							<el-option label="非营利性" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="注册地址:" prop="Address">
						<el-input v-model="information.Address" clearable maxlength="40" :disabled="operationState > 2 || isSubStore" placeholder="请输入注册地址"></el-input>
					</el-form-item>
					<!-- <el-form-item label="收货区域:" prop="ReceivingAreaName">
						<el-input v-if="operationState > 2" :disabled="true" :placeholder="cascaderDefuleTxt"></el-input>
						<el-cascader
							v-else
							:class="cascaderDefuleTxt === '' ? '' : 'cascaderBox'"
							ref="cascaderHandle"
							v-model="information.AreaId"
							filterable
							:placeholder="cascaderDefuleTxt === '' ? '请选择收货区域' : cascaderDefuleTxt"
							style="width: 100%;"
							:show-all-levels="true"
							:props="props"
							@change="cascaderHandle"
						/>
					</el-form-item>
					<el-form-item label="详细地址:" prop="ReceivingAddressName">
						<el-input v-model="information.ReceivingAddressName" clearable maxlength="40" placeholder="请输入详细地址" :disabled="operationState > 2"></el-input>
					</el-form-item> -->
					<el-form-item label="联系人:" prop="ContactsName" class="text-left">
						<el-input style="width: 250px;" v-model="information.ContactsName" clearable maxlength="10" placeholder="请输入联系人姓名" :disabled="state || isSubStore"></el-input>
					</el-form-item>
					<el-form-item label="联系电话:" prop="Phone" class="text-left last">
						<el-input style="width: 250px;" v-model="information.Phone" clearable maxlength="11" placeholder="请输入联系电话" :disabled="state || isSubStore"></el-input>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	props: {
		informationData: {
			type: Object,
			default: () => {}
		},
		defineData: {
			type: Object,
			default: () => {}
		},
		hasNamePhone: {
			type: Object,
			default: () => {}
		},
		isSubStore: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			// 提交表单数据
			information: {
				// CustomerId: '', //用户ID，PC端传空
				CustomerName: '', //机构名称
				CustomerType: 1, //客户类型id
				BusinessNature: '', // 经营性质
				Address: '', //注册地址
				AreaId: '', //省市区
				// ReceivingAreaName: '', //收获区域名称
				// ReceivingAddressName: '', //详细地址
				ContactsName: '', //联系人姓名
				Phone: '' //联系电话
			},
			// 联系人，手机号，是否能更改
			state: false,
			// 省市区级联组件默认回显txt
			cascaderDefuleTxt: '',
			// 省市区级联组件配置
			props: {
				checkStrictly: false,
				lazy: true,
				lazyLoad: this.lazyLoad,
				expandTrigger: 'click'
			},
			// 表单基础数据验证规则
			rules: {
				CustomerName: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
				CustomerType: [{ required: true, message: '请选择客户类型', trigger: 'change' }],
				BusinessNature: [{ required: true, message: '请选择经营性质', trigger: 'change' }],
				Address: [{ required: true, message: '请输入注册地址', trigger: 'blur' }],
				// ReceivingAreaName: [{ required: true, message: '请选择收货区域', trigger: 'blur' }],
				// ReceivingAddressName: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
				ContactsName: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
				Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
			},
			// 页面操作状态 1新增，2编辑，3查看
			operationState: 1
		};
	},
	watch: {
		// 监听参数变化
		informationData: {
			handler(newData, oldData) {
				// 数据变化,赋值表单默认值
				this.information = newData;
				// 向父组件派发监听事件
				this.$emit('on-trigger-change', newData.CustomerType);
			},
			deep: true,
			immediate: false
		},
		// 监听参数变化 省市区和操作权限
		defineData: {
			handler(newData, oldData) {
				// 设置页面操作状态
				this.operationState = newData.operationState;
				// 数据变化,赋值表单默认值
				this.cascaderDefuleTxt = newData.cascaderDefuleTxt;
			},
			deep: true,
			immediate: false
		},
		// 监听参数变化
		hasNamePhone: {
			handler(newData, oldData) {
				if (newData.hasNamePhone === undefined) {
					return;
				}
				let obj = JSON.parse(newData.hasNamePhone);
				if (obj.FirstOrderStatus && obj.FirstOrderStatus !== null && (obj.FirstOrderStatus !== '') & (obj.FirstOrderStatus === '2')) {
					this.state = true;
				}
			},
			deep: true,
			immediate: false
		}
	},
	mounted() {
		// 初始化函数
		this.init();
	},
	methods: {
		/*
		 * 动态加载分支
		 */
		lazyLoad(node, resolve) {
			setTimeout(() => {
				this.init(node, resolve);
			}, 300);
		},
		/*
		 * 初始化
		 */
		async init(node, resolve) {
			if (node) {
				// 获取收货区域
				const res = await this.getAction(this.$comApi.getCascadeList, {
					level: node.level === 0 ? 1 : node.level + 1,
					code: node.value
				});
				// 判断接口响应状态
				if (res.IsSuccess) {
					// 将接口返回值复制到组件中
					if (Array.isArray(res.Data)) {
						const nodes = res.Data.map(item => ({
							value: item.Code,
							label: item.FullName,
							leaf: node.level >= 2, // 5层级
							id: item.Id
						}));
						resolve(nodes);
					}
				} else {
					this.$message.error(res.Msg);
				}
			}
		},
		/*
		 * 区域级联选择器监听，选择了数据以后关闭下拉框
		 */
		cascaderHandle(e) {
			// 监听值发生变化就关闭它
			this.$refs.cascaderHandle.dropDownVisible = false;
			// 每次值变化后，同步最新的值到本地
			for (let i = 0; i < e.length; i++) {
				if (i + 1 === e.length) {
					// this.information.AreaId = e[i];
					this.information.AreaId = this.$refs.cascaderHandle.getCheckedNodes()[0].data.id;
					this.cascaderDefuleTxt = this.$refs.cascaderHandle.getCheckedNodes()[0].data.label;
				}
			}
		},
		/*
		 * 客户类型选择监听
		 */
		contactsNameChange(e) {
			// 根据所选类型切换经营性质录入展示
			let json = {
				ContactsName: e, //客户类型
				BusinessNature: '' //经营性质
			}
			// 每次选择变化，都向父组件派发监听事件
			this.$emit('on-trigger-change', json);
		},
		/*
		 * 经营类型选择监听
		 */
		businessNatureChange(e) {
			// 根据所选类型切换经营性质录入展示
			this.information.BusinessNature = e;
			let json = {
				ContactsName: '', //客户类型
				BusinessNature: e //经营性质
			}
			// 每次选择变化，都向父组件派发监听事件
			this.$emit('on-trigger-change', json);
		}
	}
};
</script>

<style lang="less">
.cascaderBox {
	input::-webkit-input-placeholder {
		color: #606266;
	}
	input:-moz-placeholder {
		color: #606266;
	}
	input::-moz-placeholder {
		color: #606266;
	}
	input:-ms-input-placeholder {
		color: #606266;
	}
}
</style>
